/* Emperielle Atelier: colour photos (loads after emp-theme.js) */
(function () {
  'use strict';
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  var SIZE = /size|taglia|taille/;

  function data(wrap) {
    if (wrap._empData !== undefined) return wrap._empData;
    var j = wrap.querySelector('[data-product-json]');
    try { wrap._empData = j ? JSON.parse(j.textContent) : null; } catch (e) { wrap._empData = null; }
    return wrap._empData;
  }

  // Product page + quick add: picking a colour shows its photo right away, even before a size is chosen.
  function showVariantMedia(wrap, variant) {
    var root = wrap.closest('[data-product-root]') || document;
    var id = String(variant.featured_media.id);
    var list = root.querySelector('[data-gallery-list]');
    if (list) {
      var item = list.querySelector('[data-media-id="' + id + '"]');
      if (item) {
        var im = item.querySelector('img');
        if (im && im.loading === 'lazy') im.loading = 'eager';
        if (item !== list.firstElementChild) list.insertBefore(item, list.firstElementChild);
        list.scrollLeft = 0;
        list.dispatchEvent(new Event('scroll'));
        if (wrap.closest('[data-main-form]') && window.matchMedia('(min-width: 990px)').matches) {
          var top = item.getBoundingClientRect().top;
          if (top < 0 || top > window.innerHeight * 0.6) {
            window.scrollTo({ top: Math.max(0, window.pageYOffset + list.getBoundingClientRect().top - 90), behavior: 'auto' });
          }
        }
      }
    }
    var quickImg = root.querySelector('[data-quick-image] img');
    if (quickImg && variant.featured_media.preview_image) {
      var src = variant.featured_media.preview_image.src;
      quickImg.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=300';
      quickImg.removeAttribute('srcset');
    }
  }

  document.addEventListener('change', function (e) {
    var fs = e.target.closest && e.target.closest('.emp-option');
    var wrap = fs && fs.closest('[data-product-form]');
    var d = wrap && data(wrap);
    if (!d || !d.variants) return;
    var sets = $$('.emp-option', wrap);
    var idx = sets.indexOf(fs);
    if (SIZE.test(String(d.options[idx] || '').toLowerCase())) return;
    var sel = sets.map(function (f) { var c = f.querySelector('[data-option-value]:checked'); return c ? c.value : null; });
    var has = function (v) { return v.featured_media && v.featured_media.id; };
    var v = d.variants.find(function (x) { return has(x) && x.options.every(function (o, i) { return sel[i] === null || o === sel[i]; }); })
      || d.variants.find(function (x) { return has(x) && x.options[idx] === sel[idx]; });
    if (v) showVariantMedia(wrap, v);
  });

  // Opened on a specific colour (e.g. ?variant= from an ad): lead with that colour's photo.
  function leadWithFeatured() {
    $$('[data-gallery-list]').forEach(function (list) {
      var f = list.querySelector('[data-featured]');
      if (f && f !== list.firstElementChild) list.insertBefore(f, list.firstElementChild);
    });
  }

  // Product cards: tapping (or hovering) a colour dot swaps the card photo and link to that colour.
  function warm(dot) {
    if (dot._empWarm) return dot._empWarm;
    var card = dot.closest('[data-product-card]');
    var img = card && card.querySelector('.emp-card__img-main');
    var pre = new Image();
    if (img && img.sizes) pre.sizes = img.sizes;
    pre.srcset = dot.getAttribute('data-srcset') || '';
    pre.src = dot.getAttribute('data-src');
    dot._empWarm = pre.decode ? pre.decode().catch(function () {}) : Promise.resolve();
    return dot._empWarm;
  }
  function pick(dot) {
    var card = dot.closest('[data-product-card]');
    if (!card) return;
    var img = card.querySelector('.emp-card__img-main');
    card._empPick = dot;
    if (img) {
      warm(dot).then(function () {
        if (card._empPick !== dot) return;
        img.srcset = dot.getAttribute('data-srcset') || '';
        img.src = dot.getAttribute('data-src');
      });
    }
    card.classList.add('is-swatched');
    $$('[data-card-swatch]', card).forEach(function (d) { d.classList.toggle('is-active', d === dot); d.setAttribute('aria-pressed', d === dot ? 'true' : 'false'); });
    var href = dot.getAttribute('data-href');
    if (href) $$('.emp-card__media-link, .emp-card__title', card).forEach(function (a) { a.href = href; });
  }
  document.addEventListener('click', function (e) {
    var dot = e.target.closest && e.target.closest('[data-card-swatch]');
    if (dot) { e.preventDefault(); pick(dot); }
  });
  if (window.matchMedia('(hover: hover)').matches) {
    document.addEventListener('mouseover', function (e) {
      var dot = e.target.closest && e.target.closest('[data-card-swatch]');
      if (dot && !dot.classList.contains('is-active')) pick(dot);
    });
  }

  // Start loading a colour's photo the moment a finger or cursor touches its dot.
  document.addEventListener('pointerdown', function (e) {
    var dot = e.target.closest && e.target.closest('[data-card-swatch]');
    if (dot) warm(dot);
  }, { passive: true });

  // Speed: once the page is idle, fetch every gallery photo and every colour photo on visible cards,
  // so switching colours never waits on the network.
  var idle = window.requestIdleCallback || function (f) { return setTimeout(f, 250); };
  function warmGallery() {
    $$('[data-gallery-list] img[loading="lazy"], [data-product-root] .emp-lightbox img[loading="lazy"]').forEach(function (img, i) {
      if (img.closest('.emp-lightbox')) return;
      img.loading = 'eager';
    });
  }
  function warmCards() {
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        io.unobserve(en.target);
        idle(function () { $$('[data-card-swatch]', en.target).forEach(warm); });
      });
    }, { rootMargin: '200px 0px' });
    $$('[data-product-card]').forEach(function (card) { if (card.querySelector('[data-card-swatch]')) io.observe(card); });
  }
  window.addEventListener('load', function () { idle(warmGallery); idle(warmCards); });

  // Desktop gallery: previous / next arrows so it browses one photo at a time, like on mobile.
  function initArrows() {
    $$('[data-gallery]').forEach(function (gallery) {
      var list = gallery.querySelector('[data-gallery-list]');
      if (!list || list.children.length < 2 || gallery.querySelector('.emp-gallery__arrow')) return;
      var icon = function (d) { return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="' + d + '"/></svg>'; };
      [['prev', -1, 'M15 5l-7 7 7 7', 'Previous photo'], ['next', 1, 'M9 5l7 7-7 7', 'Next photo']].forEach(function (a) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'emp-gallery__arrow emp-gallery__arrow--' + a[0];
        b.setAttribute('aria-label', a[3]);
        b.innerHTML = icon(a[2]);
        b.addEventListener('click', function () {
          var w = list.clientWidth || 1;
          var total = list.children.length;
          var idx = Math.round(list.scrollLeft / w) + a[1];
          if (idx < 0) idx = total - 1;
          if (idx >= total) idx = 0;
          list.scrollTo({ left: idx * w, behavior: 'smooth' });
        });
        gallery.appendChild(b);
      });
    });
  }

  function ready() { leadWithFeatured(); initArrows(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready); else ready();
})();
